import React from 'react';

import { DefaultPageProps } from '@/lib/types/shared/page.types';
import { Container } from '@mui/material';
import { GoogleReviews } from '@/components/shared';

type Props = {
    id?: string;
    addReviews?: boolean;
    reviewsOrder?: 'before' | 'after';
} & DefaultPageProps

export default function ProcessSection({ id = '', addReviews = false, reviewsOrder = 'before', params }: Props) {
    return (
        <section id={id} className="py-16 bg-white">
            <Container>
                {addReviews && <GoogleReviews params={params} />}
            </Container>
        </section>
    );
}
